module.exports = __webpack_public_path__ + "static/img/53.05a86cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/53.png
// module id = 4khF
// module chunks = 0